setRootTypename